import React, { useState } from 'react';
import { Container, Badge, Alert } from 'react-bootstrap';
import { FaArrowLeft } from 'react-icons/fa';
import { toast } from 'react-toastify';
import Header from '~/Components/Header/Header';
import AuthStorage from '~/Utils/AuthStorage';
import ModalConfirmacao from '~/Components/ModalConfirmacao';
import { excluirContrato, exportarPdfContrato } from '~/Services/Juridico/ControleContratoService';
import { caracteristicas } from '~/constant';
import useControleContrato, { extrairMensagemErro } from './useControleContrato';
import FiltroContratos from './FiltroContratos';
import GridContratos from './GridContratos';
import ModalIncluirContrato from './ModalIncluirContrato';
import ModalMudarFase from './ModalMudarFase';
import ModalAlterarItem from './ModalAlterarItem';
import ModalAnexarDocumentos from './ModalAnexarDocumentos';
import ModalAcoes from './ModalAcoes';

const ControleContrato = () => {
  const {
    filtros,
    gruposEmpresa,
    contas,
    empreendimentos,
    imoveis,
    contratos,
    total,
    loading,
    pesquisado,
    contrato,
    detalhe,
    loadingDetalhe,
    contextoExterno,
    modalIncluir,
    modalMudarFase,
    modalAlterarItem,
    modalAnexar,
    modalAcoes,
    setModalIncluir,
    setModalMudarFase,
    setModalAlterarItem,
    setModalAnexar,
    setModalAcoes,
    atualizarFiltro,
    buscar,
    mudarPagina,
    mudarOrdenacao,
    limparFiltros,
    carregarDetalhe,
    setContrato,
  } = useControleContrato();

  const podeExcluir = AuthStorage.temCaracteristica(caracteristicas.ExcluirContrato);
  const podeMudarFase = AuthStorage.temCaracteristica(caracteristicas.MudarFase);

  const [confirmExcluir, setConfirmExcluir] = useState({ show: false, item: null });

  const handleEditar = (c) => {
    carregarDetalhe(c);
    setModalAcoes(true);
  };

  const handleExcluirLinha = (c) => {
    setConfirmExcluir({ show: true, item: c });
  };

  const handleConfirmarExclusao = async (confirmado) => {
    const item = confirmExcluir.item;
    setConfirmExcluir({ show: false, item: null });
    if (!confirmado || !item) return;
    try {
      await excluirContrato({
        codigoGrupoEmpresa: item.codigo_grupo_empresa,
        codigoConta: item.conta,
        codigoBoleto: item.boleto,
      });
      toast.success('Contrato excluído com sucesso.');
      buscar();
    } catch (err) {
      toast.error(extrairMensagemErro(err));
    }
  };

  const handleExportar = async () => {
    try {
      const r = await exportarPdfContrato(filtros);
      const url = window.URL.createObjectURL(new Blob([r], { type: 'application/pdf' }));
      window.open(url, '_blank');
      // Revoga após delay pra dar tempo da nova aba carregar o blob
      setTimeout(() => window.URL.revokeObjectURL(url), 60000);
    } catch (err) {
      toast.error(extrairMensagemErro(err));
    }
  };

  const handleAcoesMudarFase = () => {
    setModalAcoes(false);
    setModalMudarFase(true);
  };

  const handleAcoesAnexar = () => {
    setModalAcoes(false);
    setModalAnexar(true);
  };

  const handleAcoesExcluir = () => {
    setModalAcoes(false);
    if (contrato) handleExcluirLinha(contrato);
  };

  const handleSalvoModal = () => {
    setModalIncluir(false);
    setModalMudarFase(false);
    setModalAlterarItem(false);
    setModalAnexar(false);
    buscar();
  };

  return (
    <Container fluid>
      <Header title="Controle de Contrato">
        {contextoExterno && (
          <Badge variant="info" className="ml-2">Vindo da Gerência</Badge>
        )}
      </Header>

      {contextoExterno && (
        <Alert variant="info" className="small py-2">
          <FaArrowLeft className="mr-1" />
          Acesso via contexto de Gerência — filtros pré-aplicados pelo boleto.
        </Alert>
      )}

      <FiltroContratos
        filtros={filtros}
        gruposEmpresa={gruposEmpresa}
        contas={contas}
        empreendimentos={empreendimentos}
        imoveis={imoveis}
        onAtualizarFiltro={atualizarFiltro}
        onBuscar={() => buscar()}
        onLimpar={limparFiltros}
        onIncluir={() => setModalIncluir(true)}
        onExportar={handleExportar}
        pesquisado={pesquisado}
        loading={loading}
      />

      <GridContratos
        contratos={contratos}
        total={total}
        filtros={filtros}
        loading={loading}
        pesquisado={pesquisado}
        contratoSelecionado={contrato}
        onSelecionar={carregarDetalhe}
        onOrdenar={mudarOrdenacao}
        onMudarPagina={mudarPagina}
        onEditar={handleEditar}
        onExcluir={handleExcluirLinha}
        podeExcluir={podeExcluir}
      />

      {/* Modais */}
      <ModalAcoes
        show={modalAcoes}
        onHide={() => setModalAcoes(false)}
        contrato={contrato}
        detalhe={detalhe}
        loadingDetalhe={loadingDetalhe}
        onMudarFase={handleAcoesMudarFase}
        onAnexar={handleAcoesAnexar}
        onExcluir={handleAcoesExcluir}
        onSalvoPendencias={() => {
          buscar();
          if (contrato) carregarDetalhe(contrato);
        }}
        podeMudarFase={podeMudarFase}
        podeExcluir={podeExcluir}
      />
      <ModalIncluirContrato
        show={modalIncluir}
        onHide={() => setModalIncluir(false)}
        onSalvo={handleSalvoModal}
      />
      <ModalMudarFase
        show={modalMudarFase}
        onHide={() => setModalMudarFase(false)}
        contrato={contrato}
        onSalvo={handleSalvoModal}
      />
      <ModalAlterarItem
        show={modalAlterarItem}
        onHide={() => setModalAlterarItem(false)}
        contrato={contrato}
        item={detalhe && detalhe.itens ? detalhe.itens[0] : null}
        onSalvo={handleSalvoModal}
      />
      <ModalAnexarDocumentos
        show={modalAnexar}
        onHide={() => setModalAnexar(false)}
        contrato={contrato}
        onSalvo={handleSalvoModal}
      />

      <ModalConfirmacao
        show={confirmExcluir.show}
        title="Confirmar Exclusão"
        message={
          confirmExcluir.item
            ? `Confirmar exclusão do contrato — Boleto ${confirmExcluir.item.boleto} / Conta ${confirmExcluir.item.conta}?`
            : ''
        }
        onClose={handleConfirmarExclusao}
      />
    </Container>
  );
};

export default ControleContrato;
